const DashboardIcon = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 12.3147V7.67681C13 7.35413 12.9334 7.03485 12.8041 6.73851C12.6748 6.44218 12.4857 6.17503 12.2482 5.95344L7.8244 1.82398C7.6016 1.61593 7.30661 1.5 7 1.5C6.69339 1.5 6.3984 1.61593 6.1756 1.82398L1.7518 5.95344C1.51433 6.17503 1.32517 6.44218 1.1959 6.73851C1.06663 7.03485 0.999965 7.35413 1 7.67681V12.3147C1 12.6291 1.12643 12.9306 1.35147 13.1528C1.57652 13.3751 1.88174 13.5 2.2 13.5H11.8C12.1183 13.5 12.4235 13.3751 12.6485 13.1528C12.8736 12.9306 13 12.6291 13 12.3147Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DashboardIcon;
